import { Component, OnInit } from '@angular/core';
import { ShoppingCartListComponent } from 'src/app/gamification/marketplace/agent-side/components/shopping-cart-list/shopping-cart-list.component';


@Component({
  selector: 'cv-cxone-order-placed',
  templateUrl: './cxone-order-placed.component.html',
  styleUrls: ['./cxone-order-placed.component.scss']
})
export class CxoneOrderPlacedComponent implements OnInit {

  constructor(private shoppingCartListComponent: ShoppingCartListComponent) { }

  ngOnInit(): void {
  }

  goToBrowse(): void {
    this.shoppingCartListComponent.goToBrowse();
  }
  goToOrders(): void {
    this.shoppingCartListComponent.goToOrders();
  }

}
